import { render, staticRenderFns } from "./calendar-day-picker-data.vue?vue&type=template&id=08a7653e&scoped=true&"
import script from "./calendar-day-picker-data.vue?vue&type=script&lang=ts&"
export * from "./calendar-day-picker-data.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-day-picker-data.vue?vue&type=style&index=0&id=08a7653e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7653e",
  null
  
)

export default component.exports